import { compact, get, isEmpty, merge } from "lodash"

type ReplaceText = (string: string, replaceWith?: string) => string

export const replaceLineBreak: ReplaceText = (
  string,
  replaceWith = "<br/>"
) => {
  return string && string.split("\n").join(replaceWith)
}

export const replaceSpace: ReplaceText = (string, replaceWith = "&nbsp;") => {
  return string && string.replace(/ /g, replaceWith)
}

export const pluralize = (word: string): string => {
  if (word.substr(-1, 1) === "y") return word.replace(/y$/, "ies")
  return `${word}s`
}

export interface IPrepareTextByFieldNameOptions {
  separator?: string
  empty?: string
}

export type PrepareTextByFieldName = (
  source: {
    [k: string]: string
  },
  fieldNames: string[],
  options?: IPrepareTextByFieldNameOptions
) => string

const DEFAULT_OPTIONS = { separator: " | ", empty: "-" }

export const prepareTextByFieldName: PrepareTextByFieldName = (
  source = {},
  fieldNames = [],
  options = DEFAULT_OPTIONS
) => {
  const { empty, separator } = merge({}, DEFAULT_OPTIONS, options)

  const concatenatedText = compact(
    fieldNames.map((fieldName) => get(source, fieldName))
  ).join(separator)

  return isEmpty(concatenatedText) ? empty : concatenatedText
}
